import { AxiosRequestConfig } from 'axios';
import { SessionService } from '@/core/services/session';
import { HttpService } from '@/core/services/http';
import { AxiosErrorInterceptor } from '@/core/types/axios-error-interceptor';
import { CoreHelper } from '@/core/helper';

export class AuthenticatedHttpService extends HttpService {
	public static get<R>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return super.get<R>(url, this.getRequestConfig(config));
	}

	public static delete<R>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return super.delete<R>(url, this.getRequestConfig(config));
	}

	public static patch<R, D = void>(url: string, data?: D, config?: AxiosRequestConfig): Promise<R> {
		return super.patch<R, D>(url, data, this.getRequestConfig(config));
	}

	public static post<R, D = void>(url: string, data?: D, config?: AxiosRequestConfig): Promise<R> {
		return super.post<R, D>(url, data, this.getRequestConfig(config));
	}

	public static put<R, D = void>(url: string, data?: D, config?: AxiosRequestConfig): Promise<R> {
		return super.put<R, D>(url, data, this.getRequestConfig(config));
	}

	public static setErrorInterceptor(interceptor: AxiosErrorInterceptor): void {
		AuthenticatedHttpService.axios.interceptors.response.use(
			(res) => res,
			interceptor,
		);
	}

	private static getRequestConfig(config?: AxiosRequestConfig): AxiosRequestConfig {
		const jwt = SessionService.getJWT();
		const headers = {
			...config?.headers,
			jwt,
		};

		return {
			...config,
			...{ headers },
		};
	}
}

AuthenticatedHttpService.setErrorInterceptor(
	CoreHelper.createAxiosErrorInterceptor(SessionService.logout, 401),
);

AuthenticatedHttpService.setErrorInterceptor(
	CoreHelper.createAxiosErrorInterceptor(
		() => {
			window.location.pathname = '#/not-found';
		},
		404,
	),
);
